/**
 *   Created by Arif Topcu in 2019
 */
import React from "react";
import { Grid, Cell } from "styled-css-grid";
import {
  selectSelectedAccountEntity,
  selectSelectedAsOfDateEntity,
  selectSelectedIsLookthru,
  selectScenarioValue,
} from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
import { useSelector } from "react-redux";
import styled from "styled-components";

const Label = styled(Cell)`
  color: #e4e4e4;
  font-size: 0.7em;
  justify-self: flex-end;
  align-self: center;
`;
const Value = styled(Cell)`
  color: #e4d995;
  font-size: 0.75em;
  justify-self: flex-start;
  align-self: center;
`;

const InfoSection = () => {
  const asOfDateEntity = useSelector(
    selectSelectedAsOfDateEntity(SelectionState.COMMITTED)
  );
  const isLookThru = useSelector(
    selectSelectedIsLookthru(SelectionState.COMMITTED)
  );
  const accountEntity = useSelector(
    selectSelectedAccountEntity(SelectionState.COMMITTED)
  );
  const selectedScenario = useSelector(
    selectScenarioValue(SelectionState.COMMITTED)
  );

  return (
    <Grid
      columns={"repeat(4, auto)"}
      rowGap={"0px"}
      columnGap={"4px"}
      rows={"repeat(4, min-content)"}
    >
      <Label>As of Date:</Label>
      <Value>{asOfDateEntity?.format("L") ?? "..."}</Value>
      <Label>Lookthru:</Label>
      <Value>{isLookThru ? "Yes" : "No"}</Value>
      <Label>Entity ID:</Label>
      <Value>{accountEntity?.entityId ?? "..."}</Value>
      <Label>Benchmark ID:</Label>
      <Value>{accountEntity?.benchmarkId ?? "..."}</Value>
      <Label>Scenario:</Label>
      <Value>{selectedScenario ?? "..."}</Value>
    </Grid>
  );
};
export default InfoSection;
